import { createSlice } from "@reduxjs/toolkit";
import { AuthUser } from "../../types/User/AuthUser";

export const userSlice = createSlice({
  name: "user",
  initialState: {
    value: null as unknown as AuthUser,
  },
  reducers: {
    setUser: (state: any, action: { payload: AuthUser; type: string }) => {
      console.log("received set user", action.payload);
      state.value = action.payload;
    },
    removeUser: (state: any, action) => {
      state.value = null as unknown as AuthUser;
    },
  },
});

export const { setUser, removeUser } = userSlice.actions;

export default userSlice.reducer;
